module.exports = __webpack_public_path__ + "static/img/metal22.8bf7f2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/metal22.jpg
// module id = TNJ3
// module chunks = 0